import { apiGet, apiPost } from './client';
import { tokenStorage } from './storage';

export async function login(loginOrEmail, password) {
  const payload = await apiPost(
    '/auth/login',
    {
      login_or_email: loginOrEmail,
      password
    },
    { auth: false }
  );

  tokenStorage.setTokens({
    accessToken: payload.access_token,
    refreshToken: payload.refresh_token
  });

  return payload;
}

export async function register(
  loginName,
  email,
  password,
  firstName,
  lastName,
  patronymic = null
) {
  return apiPost(
    '/auth/register',
    {
      login: loginName,
      email,
      password,
      first_name: firstName,
      last_name: lastName,
      patronymic
    },
    { auth: false }
  );
}

export async function logout() {
  const refreshToken = tokenStorage.getRefreshToken();
  if (!refreshToken) {
    tokenStorage.clearTokens();
    return;
  }

  try {
    await apiPost('/auth/logout', { refresh_token: refreshToken }, { auth: false });
  } finally {
    tokenStorage.clearTokens();
  }
}

export async function getCurrentUser() {
  return apiGet('/auth/me');
}

export async function requestPasswordReset(email) {
  return apiPost(
    '/auth/password/forgot',
    { email },
    { auth: false }
  );
}

export async function resetPassword(token, password) {
  return apiPost(
    '/auth/password/reset',
    { token, password },
    { auth: false }
  );
}

export async function requestEmailVerification() {
  return apiPost('/auth/email/verify/request', {});
}

export async function requestEmailVerificationPublic(email) {
  return apiPost(
    '/auth/email/verify/request-public',
    { email },
    { auth: false }
  );
}

export async function confirmEmailVerification(token) {
  return apiPost(
    '/auth/email/verify/confirm',
    { token },
    { auth: false }
  );
}

export async function getLeaderIdAuthorizationUrl() {
  return apiGet('/auth/leader-id/start', { auth: false });
}

export const getSfeduStatus = () => apiGet('/auth/sfedu/status', { auth: false });
export const getSfeduConnection = () => apiGet('/auth/sfedu/connection');
export const startSfeduSignIn = (link = false) => apiPost(
  link ? '/auth/sfedu/link' : '/auth/sfedu/start', {}, { auth: link }
);

export async function completeSfeduSignIn() {
  const payload = await apiPost('/auth/sfedu/complete', {}, { auth: false });
  tokenStorage.setTokens({ accessToken: payload.access_token, refreshToken: payload.refresh_token });
  return payload;
}

export const getPendingSfeduLink = () => apiGet('/auth/sfedu/pending-link', { auth: false });

export async function confirmSfeduLink(password) {
  const payload = await apiPost('/auth/sfedu/confirm-link', { password }, { auth: false });
  tokenStorage.setTokens({ accessToken: payload.access_token, refreshToken: payload.refresh_token });
  return payload;
}

export async function getLeaderIdStatus() {
  return apiGet('/auth/leader-id/status');
}

export async function completeLeaderIdCallback(code, state) {
  const payload = await apiGet(
    `/auth/leader-id/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
    { auth: false }
  );

  tokenStorage.setTokens({
    accessToken: payload.access_token,
    refreshToken: payload.refresh_token
  });

  return payload;
}
